<section>
    <ng-container *ngIf="hasFieldOrEditable(rendering.fields.bannerDescription)">
        <p class="description" [ngStyle]="{ color: pageData.textColor }"  *scRichText="rendering.fields.bannerDescription"></p>
    </ng-container>
    <ng-container *ngIf="hasFieldOrEditable(rendering.fields.buttonText)">
        <button class="link" [ngStyle]="{ color: pageData.textColor }" [ngClass]="{ underline: pageData.buttonUnderline }" *scRichText="rendering.fields.buttonText" (click)="viewModal()"></button>
    </ng-container>
</section>